// Indexed by region name, which callers only have as a plain string, so the keys are not narrowed
export const regionsWithAvailabilityZones: Record<string, boolean> = {
  australiaeast:      true,
  austriaeast:        true,
  brazilsouth:        true,
  canadacentral:      true,
  centralindia:       true,
  centralus:          true,
  chilecentral:       true,
  eastasia:           true,
  eastus:             true,
  eastus2:            true,
  francecentral:      true,
  germanywestcentral: true,
  indonesiacentral:   true,
  israelcentral:      true,
  italynorth:         true,
  japaneast:          true,
  japanwest:          true,
  koreacentral:       true,
  malaysiawest:       true,
  mexicocentral:      true,
  newzealandnorth:    true,
  northeurope:        true,
  norwayeast:         true,
  polandcentral:      true,
  qatarcentral:       true,
  southafricanorth:   true,
  southcentralus:     true,
  southeastasia:      true,
  spaincentral:       true,
  swedencentral:      true,
  switzerlandnorth:   true,
  uaenorth:           true,
  uksouth:            true,
  usgovvirginia:      true,
  westeurope:         true,
  westus2:            true,
  westus3:            true,
} as any;
